import { useQuery } from '@tanstack/react-query';
import { api } from '../client';

/** Live figures for the public pages — read from the database, never typed in. */
export interface SiteStats {
  venues: number;
  cities: number;
  maxCapacity: number;
  reviews: number;
  /** Average review rating, 0 when there are no reviews. */
  rating: number;
  /** Confirmed and completed bookings. */
  events: number;
}

/** A real guest review shown as a testimonial (first name only). */
export interface SiteReview {
  id: number;
  rating: number;
  comment: string;
  created_at: number;
  name: string;
  hall_id: number;
  hall_name: string;
  city: string | null;
  category: string;
}

export function useSiteStats() {
  return useQuery({
    queryKey: ['site', 'stats'],
    queryFn: () => api<SiteStats>('/site/stats'),
    staleTime: 5 * 60_000,
  });
}

export function useSiteReviews(limit = 6) {
  return useQuery({
    queryKey: ['site', 'reviews', limit],
    queryFn: () => api<{ reviews: SiteReview[] }>(`/site/reviews?limit=${limit}`),
    select: (d) => d.reviews,
    staleTime: 5 * 60_000,
  });
}
